import { render, staticRenderFns } from "./WalkIn.vue?vue&type=template&id=0bb94426"
import script from "./WalkIn.vue?vue&type=script&lang=js"
export * from "./WalkIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports